/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wpm: NonNullable<unknown> }} Event_Metrics_Wpm_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Words Per Minute {wpm}" |
*
* @param {Event_Metrics_Wpm_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_wpm_aria_label = /** @type {((inputs: Event_Metrics_Wpm_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Wpm_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Mots par minute ${i?.wpm}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Wörter pro Minute ${i?.wpm}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Parole al minuto ${i?.wpm}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Слов в минуту ${i?.wpm}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Palabras por minuto ${i?.wpm}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`每分钟字数 ${i?.wpm}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`1分あたりの単語数 ${i?.wpm}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शब्द प्रति मिनट ${i?.wpm}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Palavras por minuto ${i?.wpm}`)
	return /** @type {LocalizedString} */ (`Words Per Minute ${i?.wpm}`)
});